module.exports = __webpack_public_path__ + "static/media/popai.3c4820b8.png";